import Card from 'components/card';
import VolumeWidget from 'components/widget/VolumeWidget';
import { useEffect, useState } from 'react';
import { HiX } from 'react-icons/hi';
import { tokenService } from 'views/services/tokenService';
import { TTokenItem } from 'views/types/token';
import { TTotalAppVolumeResponse } from 'views/types/volume';

type TProps = {
  onClose: () => void;
  selectedToken: TTokenItem;
};
const TokenInfo = ({ onClose, selectedToken }: TProps) => {
  const [data, setData] = useState<null | TTotalAppVolumeResponse>(null);

  const getData = async () => {
    const res = await tokenService.getTokenAppVolume(selectedToken.id);
    setData(res);
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <Card className="relative rounded-xl bg-white p-8 shadow-lg min-w-[300px] max-w-[90%]">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-black">
          <HiX />
        </button>

        <VolumeWidget title="Token volume" data={data} />
      </Card>
    </div>
  );
};

export default TokenInfo;
